import * as React from 'react';
// import { CustomerSearch } from '../customer/_components/customer-search/customer-search.container';
// import { QuoteSearch } from '../quote/_components/quote-search/quote-search.container';
import { Section } from '@common/components';
import { ActioningList } from 'src/actioning/_components/actioning-list/actioning-list.container';
// import { Carlton } from '@common/components/carlton/carlton.component';
// import { config } from '@common/config';
import { Halloween } from '@common/components/emoji';
import * as moment from 'moment';
import { FailedEmail } from 'src/failed-email';

class DashboardComponent extends React.Component {
  render() {
    return (
      <div className="row middle-xs center-xs">
        <div className="col-md-8 mb-10 pb-10">
          <Section>
            <ActioningList />
          </Section>
        </div>
        {moment().month() === 9 && moment().date() === 31 && <Halloween />}
        <br />
        <div className="col-md-8 mb-10 pb-10">
          <Section>
            <FailedEmail />
          </Section>
        </div>
        {/* <br />
          <div className="col-md-8 mt-10 mb-10 pb-10">
            <Section>
              <QuoteSearch />
            </Section>
          </div> */}
      </div>
    );
  }
}

export default DashboardComponent;



// WEBPACK FOOTER //
// ./src/dashboard/dashboard.tsx